import Accounts from "components/views/Accounts";
import Admin from "components/views/Admin";
import CashflowPlus from "components/views/CashflowPlus";
import Dashboard from "components/views/Dashboard";
import Payday from "components/views/Payday";
import TransactionSettings from "components/views/TransactionSettings";
import { createBrowserRouter } from "react-router-dom";
import Root from "./Root";

const DASHBOARD_ROUTE = { handle: { title: "Dashboard" }, path: "/dashboard" };

const router = createBrowserRouter([
  {
    path: "",
    element: <Root />,
    children: [
      {
        handle: { title: "Accounts" },
        path: "/accounts",
        element: <Accounts />,
      },
      {
        ...DASHBOARD_ROUTE,
        element: <Dashboard />,
      },
      {
        handle: { title: "Switchboard", parent: DASHBOARD_ROUTE },
        path: "/transaction-settings",
        element: <TransactionSettings />,
      },
      {
        handle: { title: "About Switchboard", parent: DASHBOARD_ROUTE },
        path: "/switchboard",
        element: <CashflowPlus />,
      },
      {
        handle: { title: "Payday", parent: DASHBOARD_ROUTE },
        path: "/payday",
        element: <Payday />,
      },
      {
        handle: { title: "Admin" },
        path: "/admin",
        element: <Admin />,
      },
    ],
  },
]);

export default router;
